import dayjs from 'dayjs';
import React, { useState, useEffect, useRef } from 'react';
import StyledBox, {
  RangePickerTextField,
  StyledTooltip,
} from 'views/rebranded-module/GeoViewV2/components/GeoRangePicker/GeoRangePicker.styles';
import {
  Button,
  Alert,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import CloseIcon from '@mui/icons-material/Close';
import DatePicker from 'react-multi-date-picker';
import useRangePickerLocalization from 'views/GeoView/hooks/useRangePickerLocalization';
import { DatePickerHeader } from 'views/rebranded-module/GeoViewV2/components';

const GeoRangePicker = (props) => {
  const {
    className,
    value,
    onChange,
    disabled,
    disableInfo,
    handleClearRangePicker,
    ...restOfProps
  } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [geoWidgetDate, setGeoWidgetDates] = useState(value);
  const appNavigator = useAppNavigator();
  const localizationObj = useRangePickerLocalization();
  const cmsData = useContent('GeoPage');
  const datePickerRef = useRef<any>(null);

  const checkNoChange = (newValue) => {
    if (!newValue[0] && !newValue[1]) return undefined;
    if (newValue[0] || newValue[1]) {
      if (newValue[0] && newValue[1]) {
        if (
          newValue[0].isSame(geoWidgetDate[0])
          && newValue[1].isSame(geoWidgetDate[1])
        ) {
          return undefined;
        }
      }
    }
    return true;
  };

  useEffect(() => {
    dayjs.locale(mapNamedLocaleToLocale[appNavigator.locale].toLowerCase());
    return () => {
      dayjs.locale(mapNamedLocaleToLocale.en.toLowerCase());
    };
  }, []);

  useEffect(() => {
    if (value[0] !== geoWidgetDate[0] || value[1] !== geoWidgetDate[1]) {
      setGeoWidgetDates(value);
    }
  }, [value]);
  const handelCloseCalenderClick = () => {
    datePickerRef.current?.closeCalendar();
  };
  return (
    <StyledBox>
      <DatePicker
        ref={datePickerRef}
        range
        className={`${geoWidgetDate[0] && !geoWidgetDate[1] ? 'single-day' : ''} ${className}`}
        dateSeparator=" - "
        numberOfMonths={isMobile ? 1 : 2}
        format="MMM DD"
        monthYearSeparator={new String('')}
        locale={localizationObj}
        render={(
          <RangePickerTextField
            label={cmsData.addDatesLabel}
            disabled={disabled}
            focused={false}
            onClick={(e) => {
              (e.target as HTMLInputElement).blur();
            }}
          />
        )}

        disabled={disabled}
        value={geoWidgetDate.map((date) => date?.toDate())}
        onChange={(dates) => {
          const newValue = dates.map((date) => dayjs(date));
          if (!checkNoChange(newValue)) return;
          setGeoWidgetDates(newValue);
          onChange(newValue);
          if (newValue[0] && newValue[1]) document.body.click();
        }}
        {...restOfProps}
        // inject header using plugins API
        plugins={
            [<DatePickerHeader
              key="header"
              position="top"
              pickupDate={geoWidgetDate[0]}
              dropoffDate={geoWidgetDate[1]}
              handelCloseCalenderClick={handelCloseCalenderClick}
             />]
}

      />
      {disabled && (
        <StyledTooltip
          enterTouchDelay={0}
          title={<Alert severity="error">{disableInfo}</Alert>}
        >
          <Button className="GRPTooltipButton">&nbsp;</Button>
        </StyledTooltip>
      )}
      {geoWidgetDate && (geoWidgetDate[0] || geoWidgetDate[1]) && (
        <IconButton
          onClick={() => {
            setGeoWidgetDates([null, null]);
            handleClearRangePicker();
          }}
          className="GRPCloseButton"
        >
          <CloseIcon />
        </IconButton>
      )}
    </StyledBox>
  );
};

export { GeoRangePicker };
